import PropTypes from "prop-types";
import Tooltip from "@shared/v2/Tooltip";

const PhoneStatusIcon = ({ callIcon, tooltip }) => (
  <div className="tw-ml-4px">
    <Tooltip placement="top" innerClassName="tw-max-w-[250px]" trigger={callIcon} content={tooltip} />
  </div>
);

PhoneStatusIcon.propTypes = {
  callIcon: PropTypes.func,
  tooltip: PropTypes.string,
};

PhoneStatusIcon.defaultProps = {
  callIcon: null,
  tooltip: null,
};

export default PhoneStatusIcon;
